import { CatalogGoalsComponent } from './catalog-goals.component';

export default angular
  .module('sfMobile.components.catalog-goals', ['sfMobile.services.places'])
  .component('sfCatalogGoals', CatalogGoalsComponent).name;
